import fetch from 'isomorphic-fetch';
import {commonHeaders, commonErrorHandler} from './fetch.util';

export const IDENTIFICATION_RESPONSE = 'IDENTIFICATION_RESPONSE';

export function identificationResponse(result) {
  return {
    type: IDENTIFICATION_RESPONSE,
    result,
  };
}

export function fetchIdentificationWithRequestTokenOrRedirectOnFail(
  identityToken,
  redirectUrl,
  history,
  failureMessage = '본인인증 정보 확인에 실패했습니다.\n첫 화면으로 전환됩니다.',
  currentUserDI
) {
  if (!identityToken) {
    if (failureMessage) {
      alert(failureMessage);
    }
    history.replace(redirectUrl);
    return () => {};
  }

  return dispatch => {
    fetch(`${API_URL}/identifications/by-request-token/${identityToken}`, {
      headers: commonHeaders(),
    })
      .then(commonErrorHandler)
      .then(response => response.json())
      .then(result => {
        if (currentUserDI && currentUserDI !== result.discHash) {
          alert('본인 인증 정보가 일치하지 않습니다.');
          history.push(redirectUrl);
          return;
        }

        if (result && result.name && result.discHash) {
          dispatch(identificationResponse(result));
        } else {
          if (failureMessage) {
            alert(failureMessage);
          }
          history.push(redirectUrl);
        }
      })
      .catch(() => history.replace(redirectUrl));
  };
}
